<!-- 加载全部数据 -->
<template>
  <div class='finish_wrap'>
    <div class="finish_body">
      <div class="finish_text">{{text}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadAll',
  props: {
    text: {
      type: String,
      default: '已经加载全部内容'
    }
  },
  data() {
    return {

    };
  },

  components: {},

  methods: {

  },

  mounted() {

  },
}
</script>
<style lang='less' scoped>
.finish_wrap {
  height: 70px;
  box-sizing: border-box;
  position: relative;
  .finish_body {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    font-size: 12px;
    color: #999;
    line-height: 18px;
    width: max-content;
    .finish_text {
      &::before {
        content: "-";
        position: relative;
        top: -0.5px;
        margin: 0 2px 0 8px;
      }
      &::after {
        content: "-";
        position: relative;
        top: -0.5px;
        margin: 0 8px 0 2px;
      }
    }
  }
}
</style>